// extracted by mini-css-extract-plugin
export var productImage = "_on-1";
export var viewLink = "_on-2";
export var wishlistItem = "_on-0";